import React from 'react';
// components
import CostForm from '../../forms/CostForm';
import Modal from 'shared/modals/Modal';

const CostModal = ({
  onClose,
  values,
  initialValues,
  isSubmitting,
  setSubmitting
}) => {
  return (
    <Modal isOpen={true} title={`${initialValues && initialValues.id ? 'Edit' : 'Add'} Cost`} handleClose={onClose} containerStyle='medium'>
      <section className={`cost-form ${isSubmitting ? 'hide-overflow' : ''}`}>
        <CostForm data={initialValues} onClose={onClose} setSubmitting={setSubmitting} />
      </section>
    </Modal>
  );
};

export default CostModal;
